import React, { useState, useEffect, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ProfileContext } from '../../context/profile';

const columns = [
    {
        name: 'Title',
        // selector: (row) =>
        //     row.reference_type === 1 ? (
        //         <Link to={`/task/view/${row.referenceId}`}>{row.title}</Link>
        //     ) : (
        //         row.title
        //     ),
        selector: (row) => row.title,
    },
    {
        name: 'Description',
        selector: (row) => row.description,
    },
    // {
    //     name: 'Time Since',
    //     selector: (row) => row.timeSince,
    // },
    // {
    //     name: 'Created At',
    //     selector: (row) => moment(row.createdAt).format('YYYY-MM-DD HH:mm'),
    // },
];

const Notification = () => {
    const { saveUnread } = useContext(ProfileContext);

    const [pages, setPages] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [data, setData] = useState([]);

    const fetchData = async () => {
        try {
            const response = await axiosAuthInstance.get('notification/list',
                { page: pages, limit: limit }
            );
            if (response && response.status === 200) {
                const transformedData = response?.data?.result?.n?.docs;

                setData(transformedData);
                setTotalRows(response?.data?.result?.n?.totalDocs);
                saveUnread(response?.data?.result?.unreadCount)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const readNotifications = async () => {
        try {
            const response = await axiosAuthInstance.put('notification/read');
            if (response && response.status === 200) {
                fetchData();
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        readNotifications()
    }, [])

    useEffect(() => {
        fetchData();
    }, [pages, limit]);

    const handlePageChange = (newPage) => {
        setPages(newPage);
    };

    const handlePerRowsChange = (newLimit) => {
        setLimit(newLimit);
        setPages(1);
    };

    return (
        <div className="p-4">
            <DataTable
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
            />
        </div>
    );
};

export default Notification;
